import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_BOAT_PILOTAGES",
    applicationRights: Rights,
    title: 'Oppdrag for losb&aring;t',
    text: 'Oppdrag for losb&aring;t',
    icon: 'ship',
    showOnDashboardByDefault: true,
    url: "/current-pilotages",
    sequenceNo: 17610,
    routes: Routes
})
